import { styled } from '@mui/material';
import { forwardRef } from 'react';

import Dropdown from 'shell/components/Dropdown';
import Icon from 'shell/components/Icon';
import IconButton from 'shell/components/IconButton';
import Link from 'shell/components/Link';
import Stack from 'shell/components/Stack';
import Text from 'shell/components/Text';
import { getFileIconKind, getPrettyTimestamp, getS3FileURL } from 'utils/helper';

const RootStack = styled(Stack)(() => {
    return {
        width: '100%',
    };
});

const CustomIcon = styled(Icon)(() => {
    return {
        fontSize: '1rem',
    };
});

const DataStack = styled(Stack)(() => {
    return {
        flex: 1,
    };
});

const CustomLink = styled(Link)(() => {
    return {
        textDecoration: 'none',
    };
});

export default forwardRef(({ file, getNameById, options, onSelect, ...rest }, ref) => {
    return (
        <RootStack ref={ref} {...rest} direction={'row'} spacing={2}>
            <CustomIcon kind={getFileIconKind(file.data.type)} />
            <DataStack spacing={1}>
                <CustomLink rel={'noopener noreferrer'} target={'_blank'} to={getS3FileURL(file.data)}>
                    <Text variant={'p3'}>{file.data.name}</Text>
                </CustomLink>
                <Text color={'light'} variant={'p3'}>
                    {getNameById(file.owner_account_id)}
                </Text>
                <Text color={'light'} variant={'p4'}>
                    {getPrettyTimestamp(file.created_on)}
                </Text>
            </DataStack>
            <Dropdown
                id={`dropdown-${file.id}`}
                options={options}
                rootComponent={<IconButton kind={'moreHorizontal'} size={'small'} variant={'square'} />}
                onSelect={onSelect}
            />
        </RootStack>
    );
});
